import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Button, Form, message, Row, Col } from "antd";

import FormInput from "components/FormInput/FormInput";
import { withAppContext } from "contexts/AppContext/AppContext";
import {
  buildAdviseePoliciesUri,
  buildAdviseesUri,
  buildDashboardUri,
  buildPoliciesUri,
  buildSignUpUri,
} from "utils/routes";

import {
  FooterText,
  LogoContainer,
  LoginContainer,
  LoginFieldsContainer,
  WelcomeText,
} from "./Login.styles";

import ForgotPasswordModal from "../ForgotPassword/components/ForgotPassword.modal";
import { initChatBot } from "utils/auth";

const { useForm } = Form;

const Login = ({ onLogin, isUserLoading, isLoggedIn, isContributor }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [forgot_password_modal, set_forgot_password_modal] = useState(false);

  const history = useHistory();
  const [form] = useForm();

  const redirectPath = window.localStorage.getItem("redirect_path");

  useEffect(() => {
    console.log("window", window);
    console.log("redirectPath", redirectPath);

    if (!isLoading && !isUserLoading) {
      if (isLoggedIn) {
        message.info("You are already logged in.");

        if (isContributor) {
          history.push(buildPoliciesUri());
        } else {
          history.push(buildDashboardUri());
        }

        // history.push(buildAdviseesUri());
      }
    }
  }, [isLoggedIn, isUserLoading, isLoading, history]);

  const handleOnLoginButtonClick = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const values = await form.validateFields();
      return onLogin(values)
        .then((response) => {
          // Init chatbot once user login
          if (response.user) {
            initChatBot(response.user);
          }

          if (redirectPath) {
            history.push(redirectPath);
            window.localStorage.removeItem("redirect_path");
          } else {
            if (response.user.role === "contributor") {
              history.push(buildPoliciesUri());
            } else {
              history.push(buildDashboardUri());
            }
          }
        })
        .catch((error) => {
          form.setFields([
            { name: "username", errors: ["Invalid username or password"] },
            { name: "password", errors: ["Invalid username or password"] },
          ]);

          setIsLoading(false);
        });
    } catch (error) {}
  };

  return (
    <LoginContainer>
      <LogoContainer />
      <WelcomeText>Welcome Back!</WelcomeText>
      <LoginFieldsContainer>
        <Form form={form}>
          <FormInput
            label="Username"
            name="username"
            requiredErrorMessage="Please enter your username to login."
          />
          <FormInput
            extraProps={{
              type: "password",
            }}
            label="Password"
            name="password"
            type="password"
            requiredErrorMessage="Please enter your password to login."
          />
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%", height: "38px" }}
            onClick={handleOnLoginButtonClick}
          >
            Login
          </Button>
        </Form>

        <Row justify="center" style={{ marginTop: 16 }}>
          <a
            style={{ color: "#d7a301", fontSize: 14 }}
            onClick={() => set_forgot_password_modal(true)}
          >
            Forgot Password?
          </a>
        </Row>

        <Row justify="center" style={{ marginTop: 16 }}>
          <a
            style={{ color: "#d7a301", fontSize: 14 }}
            onClick={() => history.push(buildSignUpUri())}
          >
            New User? Sign Up Now!
          </a>
        </Row>
      </LoginFieldsContainer>
      <FooterText>Brought to you by Finport Tech Sdn Bhd</FooterText>

      <ForgotPasswordModal
        visible={forgot_password_modal}
        CloseModal={() => set_forgot_password_modal(false)}
      />
    </LoginContainer>
  );
};

export default withAppContext(Login);
